import { assign } from "svelte/internal";
import Configuration from "./config"
import util from "./js/util"
import axios from "axios"

let conf;

try {
    conf = Configuration.getConfiguration();
} catch (error) {
    console.log(error);
}

const getHeaders = () => {
   // const userData = localStorage.getItem('user');
    const userData = sessionStorage.getItem('user');
    if (!userData)  console.error('Usuario no encontrado');
    const parsedUser = JSON.parse(userData);
    const destine = parsedUser?.destine;
    return {
        Authorization: "Bearer " + sessionStorage.getItem("token"),
        'Content-Type': 'application/json',
        'x-tenant': destine
    };
};

const toIsoZ = (v) => {
    if (v instanceof Date) return v.toISOString();
    const s0 = String(v || "").trim();
    if (!s0) return "";
    let s = s0.replace(" ", "T");
    if (/[zZ]|[+\-]\d{2}:\d{2}$/.test(s)) {
        if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}Z$/i.test(s)) return s.replace(/Z$/i, ":00Z");
        return s;
    }
    if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(s)) return `${s}:00Z`;
    if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return `${s}T00:00:00Z`;
    return s.endsWith("Z") ? s : s + "Z";
};

const serverConnection = (() => {


    let headers = { "Content-Type": "application/json;charset=UTF-8","x-tenant": sessionStorage.getItem("user") ?  JSON.parse(sessionStorage.getItem("user")).destine : "" };

    const login = async (username, password) => {
        let payload = { username, password };
        const tenant = username.split('@');
        headers["x-tenant"] = tenant.length > 1 ? tenant[1]:"public" ;
        return axios.post(`${conf.API}/adminusers/login`, payload,{ headers })
    };

    const client = {
        list: async (params = "") => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            if (params) { params = util.serialize(params) }
            return axios.get(`${conf.API}/clients?${params}`, { headers });
        },
        save: async (payload) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.post(`${conf.API}/clients`, payload, { headers });
        },
        remove: async (id) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.delete(`${conf.API}/clients/${id}`, { headers });
        },
        checkProviderCredential: async (params) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            params = util.serialize(params)
            return axios.get(`${conf.APIUSERS}/clients/checkProviderCredential?${params}`, { headers });
        },
        checkClientCredential: async (payload) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            console.log("Checking client c redentials", payload);
            return axios.post(`${conf.API}/games/client/${payload.client_id}/provider/${payload.provider}/currency/${payload.currency}/checkCredentialsGames`, payload, { headers });
        },
        listCredentialsGames: async (environment) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.get(`${conf.API}/secrets?environment=${environment}`, { headers});
        },
        saveCredentials: async (payload, section) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            headers.section = section;
            return axios.post(`${conf.API}/secrets`, payload, { headers });
        },
        deleteCredentials: async (payload) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            headers.section = payload.section;
            return axios.delete(`${conf.API}/secrets?secretName=${payload.keyId}`, { headers });
        },
        listCarrusels: async (params) =>{
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            let query = util.serialize(params)
            return axios.get(`${conf.API}/banners?${query}`, { headers });
        },
        saveCarrusel: async (payload) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            // headers["Content-Type"] = "multipart/form-data";
            return axios.post(`${conf.API}/banners`, payload, { headers });
        },

        obtainPresignedURL: async (params) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.post(`${conf.API}/banners/presigned-url`,params,{ headers });
        },
        
        deleteCarrusel: async (params) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            if (params) { params = util.serialize(params) }
            return axios.delete(`${conf.API}/banners?${params}`, { headers });
        },
        listTopGames: async (params) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            let query = util.serialize(params);
            return axios.get(`${conf.API}/topGame?${query}`, { headers });
        },
        saveGamesPosition: async (payload) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.post(`${conf.API}/topGame`, payload, { headers });
        },
        listSections: async () => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.get(`${conf.API}/section`, { headers });

        },
        listTypes: async () =>{
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.get(`${conf.API}/types`, { headers });
        },
        addType: async (type) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.post(`${conf.API}/types`, type, { headers });
        },
        deleteTops: async (id) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.delete(`${conf.API}/topGame/${id}`, { headers }); 
        },
        updateEndpoint: async (payload) => {
            // payload debe contener { client_id, new_endpoint }
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            // Header especial para autenticación interna
            return axios.post(`${conf.API}/clients/updateEndpoint`, payload, { headers });
        },
        generateReverseCredentials: async (payload) => {
            // payload debe contener { client_id, new_endpoint }
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            // Header especial para autenticación interna
            return axios.post(`${conf.API}/integrations/credentials`, payload, { headers });
        },
        getSportbookProvider: async (clientCode) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.get(`${conf.API}/clients/${clientCode}/sportbook-provider`, { headers });
        },
        saveSportbookProvider: async (clientCode, payload) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.post(`${conf.API}/clients/${clientCode}/sportbook-provider`, payload, { headers });
        },
        getByCode: async (code) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return await axios.get(`${conf.API}/clients/code/${code}`, { headers });
        },
    }

    const provider = {
        list: async (params = {}) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            const query = util.serialize(params);
            const url = `${conf.API}/providers${query ? `?${query}` : ""}`;
            const res = await axios.get(url, { headers });
            return res.data.providers;
        },
        listByClient: async (params) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            let query = util.serialize(params)
            return axios.get(`${conf.API}/games/providers?${query}`, { headers });
        },
        listByClientByName: async (params) => {
            let clientName = params.clientName;
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.get(`${conf.API}/games/providers?clientName=${clientName}`, { headers });
        },
        listProvidersByCategoryOrType: async (params) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            let query = util.serialize(params)
            return axios.get(`${conf.API}/games/provider/category/type?${query}`, { headers });
        },
        listBrands: async (provider) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.get(`${conf.API}/games/providers/${provider}/brands`, { headers });
        },
        listGames: async (clientId, provider = null, brand = null) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            let query = `clientId=${clientId}`;
            if (provider) query = query + `&provider=${provider}`
            if (brand) query = query + `&brand=${brand}`
            return axios.get(`${conf.API}/games?${query}`, { headers });
        },
        removeBrands: async (payload) => {
           /* const headers = {
                Authorization: "Bearer " + sessionStorage.getItem("token"),
                'Content-Type': 'application/json' 
            };*/
            const headers = getHeaders();
            let payload2 = {
                clienteid: payload.clientId, 
                provider: payload.provider,
                action: payload.action,
                brands: payload.brands,
                category: payload.category,
                type: payload.type,
                original: payload.original,
                direct: payload.direct
            };
            if (!payload2.category) delete payload2.category;
            if (!payload2.type) delete payload2.type;
            if (!payload2.original) delete payload2.original;
            if (!payload2.direct) delete payload2.direct;
            return axios.post(`${conf.API}/games/client/${payload.clientId}/provider/${payload.provider}`, payload2, { headers });
        },
        
        addBrands: async (payload) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            let payload2 = {
                brands: payload.brands,
                action: payload.action,
                category: payload.category,
                type: payload.type,
                original: payload.original,
                direct: payload.direct
            }
            if (!payload2.category) delete payload2.category
            if (!payload2.type) delete payload2.type
            if (!payload2.original) delete payload2.original
            if (!payload2.direct) delete payload2.direct
            return axios.post(`${conf.API}/games/client/${payload.clientId}/provider/${payload.provider}`, payload2 , { headers });
        },
        listBrandsWithoutClient: async (params) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            let query
            query = util.serialize(params)
            return axios.get(`${conf.API}/games/client?${query}`, { headers });
        },
    }

    const games = {
        list: async (params = '') => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            if (params) { params = util.serialize(params) }
            console.log("Headers", headers);
            return axios.get(`${conf.API}/games?${params}`, { headers });
        },
        listCategories: async (params) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            let query = util.serialize(params)
            return axios.get(`${conf.API}/games/category?${query}`, { headers });
        },
        listCategoriesByClientCode: async (params) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            let query = util.serialize(params)
            return axios.get(`${conf.API}/games/category?${query}`, { headers });
        },
        listTypes: async (category) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.get(`${conf.API}/games/${category}/types`, { headers });
        },
        listProvider: async () => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.get(`${conf.API}/games/providers`, { headers });
        },
        listBrands: async (provider) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.get(`${conf.API}/games/providers/${provider}/brands`, { headers });
        },
        listBrandsByClient: async (params) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            let query;
            query = util.serialize(params)
            if(headers["x-tenant"] === "babieca") return axios.get(`${conf.API}/games/brandsNotByclient?${query}`, { headers });
            else return axios.get(`${conf.API}/games/brandsByclient?${query}`, { headers }); 
        },
        listBrandsByClient_v2: async (params) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            let query;
            query = util.serialize(params)
             return axios.get(`${conf.API}/games/brandsByclient?${query}`, { headers }); 
        },
        listBrandsNotByClient: async (params) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            let query;
            query = util.serialize(params)
            return axios.get(`${conf.API}/games/brandsNotByclient?${query}`, { headers });
        },
        listBrandsByProvider: async (params) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            let query;
            query = util.serialize(params)
            return axios.get(`${conf.API}/games/brandsByProvider?${query}`, { headers });
        },
        saveGame: async (formData) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            headers["Content-Type"] = "multipart/form-data";
            return axios.post(`${conf.API}/games`, formData, { headers });
        },
        remove: async (id) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.delete(`${conf.API}/games/${id}`, { headers });
        },
        listGamesbyclient: async (params) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            let query
            query = util.serialize(params)
            return axios.get(`${conf.API}/games?${query}`, { headers });
        },
        listGamesWithoutClient: async (params) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            let query = `clientId=${params.clientId}`;
            if (params.provider) query = query + `&provider=${params.provider}`
            if (params.brand) query = query + `&brand=${params.brand}`
            if (params.search) query = query + `&search=${params.search}`
            return axios.get(`${conf.API}/games/notwithclient?${query}&page=${params.page}&xpage=${params.xpage}`, { headers });
        },

        removeGamesbyclient: async (payload) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.delete(`${conf.API}/clients/${payload.clientId}/games/${payload.gameId}`, { headers });
        },
        addGametoClient: async (payload) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.post(`${conf.API}/clients/${payload.clientId}/games/${payload.gameId}`, payload, { headers });
        },
        listPragmaticFrbGames: async () => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.get(`${conf.GATEWAYAPI}/freespins/frbGamesPragmatic`, { headers });
        },
    }

    const gamers = {
        list: async (params) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            if (params) { params = util.serialize(params) }
            return axios.get(`${conf.API}/users?${params}`, { headers });
        },
        listV2: async (params) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            if (params) { params = util.serialize(params) }
            return axios.get(`${conf.API}/users/v2?${params}`, { headers });
        }
    }

    const adminusers = {
        list: async (params) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            if (params) { params = util.serialize(params) }
            return axios.get(`${conf.API}/users?${params}`, { headers });
        },
        remove: async (id) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.delete(`${conf.API}/adminusers/${id}`, { headers });
        },
        save: async (payload) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            headers["Content-Type"] = "application/json";
            return axios.post(`${conf.API}/users`, payload, { headers });
        },
        changePassword: async (payload) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.post(`${conf.API}/adminusers/change-password`, payload, { headers });
        }
    }

    const admins = {
        list: async (params) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            if (params) { params = util.serialize(params) }
            return axios.get(`${conf.API}/users/admins?${params}`, { headers });
        },
        save: async (payload) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            headers["Content-Type"] = "application/json";
            return axios.post(`${conf.API}/users`, payload, { headers });
        },
        remove: async (id) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.delete(`${conf.API}/adminusers/${id}`, { headers });
        },
        getCredentials: async (prefix) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.get(`${conf.API}/credentials?prefix=${prefix}`, { headers });
        },
        saveCredential: async (payload) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            headers["Content-Type"] = "application/json";
            return axios.post(`${conf.API}/credentials`, payload, { headers });
        },
        removeCredential: async (key) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.delete(`${conf.API}/credentials?key=${encodeURIComponent(key)}`, { headers });
        },
        listClients: async (params) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            if (params) { params = util.serialize(params) }
            return axios.get(`${conf.API}/clients?${params}`, { headers });
        }
    }

    const management = {
        list: async () => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.get(`${conf.API}/users/management`, { headers });
        }
    }

    const credentials = {
        list: async (prefix) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.get(`${conf.API}/credentials?prefix=${prefix}`, { headers });
        },
        save: async (payload) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            headers["Content-Type"] = "application/json";
            return axios.post(`${conf.API}/credentials`, payload, { headers });
        },
        remove: async (key) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.delete(`${conf.API}/credentials?key=${encodeURIComponent(key)}`, { headers });
        }
    }

    const work = {
        list: async () => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.get(`${conf.API}/work/`, { headers });
        },
        listUsers: async () => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.get(`${conf.API}/work/users`, { headers });
        },
        listGroups: async () => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.get(`${conf.API}/work/groups`, { headers });
        },
        listItemsByGroup: async (groupId) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.get(`${conf.API}/work/itemsbygroup/${groupId}`, { headers });
        }

    }

    const freespin = {
        list: async (params) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            if (params) { params = util.serialize(params) }
            return axios.get(`${conf.GATEWAYAPI}/freespins/?${params}`, { headers });
        },

        remove: async (id, provider) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.delete(`${conf.GATEWAYAPI}/freespins/${id}/${provider}`, { headers });
        },

        create: async (payload) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.post(`${conf.GATEWAYAPI}/freespins/`, payload, { headers });
        },
        authCampaign: async() =>{
            let payload = {
                clientId: "ADMINBO",
                clientSecret: "123456"
            }
            return axios.get(`${conf.GATEWAYAPI}/auth`, payload);
        },
        syncCampaign: async() =>{
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.get(`${conf.GATEWAYAPI}/first/syncCampaigns`);
        },
        listPlatforms: async () => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.get(`${conf.GATEWAYAPI}/platform`);
        },
        listCampaigns: async (params) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            if (params) { params = util.serialize(params) }
            return axios.get(`${conf.GATEWAYAPI}/campaigns/search?${params}`);
        }
    }

    const bonus = {
        list: async (params) => {
            headers.Authorization = sessionStorage.getItem("token");
            if (params) { params = util.serialize(params) }
            return axios.get(`${conf.GATEWAYAPI}/campaigns/search?${params}`);
        },
        listPlatforms: async () => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.get(`${conf.GATEWAYAPI}/platform`);
        },
        save: async (payload) => {
            headers.Authorization = sessionStorage.getItem("token");
            return axios.post(`${conf.APIUSERS}/bonus/api/bonus`, payload, { headers });
        },
        assignPlatform: async (payload) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.post(`${conf.GATEWAYAPI}/platform`, payload);
        },
        listBonus: async (params) =>{
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            if (params) { params = util.serialize(params) }
            return axios.get(`${conf.GATEWAYAPI}/bonus/search?${params}`);
        },
        saveBonus: async (payload)=>{
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.post(`${conf.GATEWAYAPI}/first/assign`, payload);
        },
        deleteBonus: async (params)=>{
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.delete(`${conf.GATEWAYAPI}/first/cancel/${params.code}`);
        },
        listFreeBets: async (params) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            if (params) { params = util.serialize(params) }
            return axios.get(`${conf.GATEWAYAPI}/freebets/search?${params}`);
        },
        saveFreeBet: async (payload) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.post(`${conf.GATEWAYAPI}/freebets/assign/${payload.bonusId}`, payload);
        },
        deleteFreeBet: async (params) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.delete(`${conf.GATEWAYAPI}/freebets/cancel/${params.code}`);
        }
    }


    const trx = {
        list: async (params = '') => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            if (params) { params = util.serialize(params) }
            return axios.get(`${conf.API}/trx/list?${params}`, { headers });
        },
        report: async (params = {}) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            let query = util.serialize(params);
            query = query.replace("mode=A&","");
            const url = `${conf.API}/trx/report${query ? `?${query}` : ""}`;
            return axios.get(url, { headers });
        },
        listOnlyDeportivas: async (trxid) => {
            //headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.get(`${conf.API}/trx/search/${trxid}`, { headers });
        },
        logs: async (params = '') => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            if (params) { params = util.serialize(params) }
            return axios.get(`${conf.API}/trx/logs?${params}`, { headers });
        },
        paymentDirect: async (payload) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.post(`${conf.API}/trx/paymentDirect`, payload, { headers });
        },       
        save: async (payload) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.post(`${conf.API}/trx`, payload, { headers });
        },
    }

    const brands = {
        list: async (params) => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            if (params) { params = util.serialize(params) }
            return axios.get(`${conf.API}/brands?${params}`, { headers });
        },
        listBrandsByCategory: async () => {
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.get(`${conf.API}/games/brandsByCategory`, { headers });
        },
        saveBrand: async (params, formData) => {
            let brand = params.brand;
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            headers["Content-Type"] = "multipart/form-data";
            return axios.post(`${conf.API}/brands/uploadimage?brand=${brand}`, formData, { headers });
        }
    }

    const clientsShare = {
        saveClientsNotShare: async (payload) => {
            headers["x-user"] = JSON.parse(sessionStorage.getItem("user")).username;
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            headers["x-tenant"] = "public";
            payload.identifier = payload.schema_name;
            return axios.post(`${conf.API}/tenant/save`, payload, { headers });
        },
        changeStatusClientsNotShare: async (payload) => {
            headers["x-user"] = JSON.parse(sessionStorage.getItem("user")).username;
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            headers["x-tenant"] = "public";
            payload.identifier = payload.schema_name;
            return axios.post(`${conf.API}/tenant/save`, payload, { headers });
        },
        saveUserToClientNotShare: async (payload) => {
            headers["x-user"] = JSON.parse(sessionStorage.getItem("user")).username;
            headers["x-tenant"] = payload.schema_name;
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.post(`${conf.API}/tenant/save/user/tenant`, payload, { headers });
        },
        getClientsNotShare: async () => {
            headers["x-user"] = JSON.parse(sessionStorage.getItem("user")).username;
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.get(`${conf.API}/tenant/list`, { headers });
        },
        saveGamesToClientNotShare: async (params) => {
            headers["x-tenant"] = params.destine;
            delete params.destine;
            let payload = params;
            headers["x-user"] = JSON.parse(sessionStorage.getItem("user")).username;
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");            
            return axios.post(`${conf.API}/tenant/save/games`,payload, { headers });
        }
    }

    const logs = {
        traceByCodeAndDates: async ({ trxSearch, startDate, type = "" }) => {
            headers["x-user"] = JSON.parse(sessionStorage.getItem("user"))?.username;
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");
            return axios.get(`${conf.API}/logs/traceTransaction`, {
                headers,
                params: {
                    transactionId: trxSearch,
                    startDate: toIsoZ(startDate),
                    type
                }
            });
        },
        resolveUserMessage: async ({ username }) => {
            headers["x-user"] = JSON.parse(sessionStorage.getItem("user"))?.username;
            headers.Authorization = "Bearer " + sessionStorage.getItem("token");

            const query = util.serialize({ username });
            return axios.get(`${conf.API}/logs/resolveUserId?${query}`, { headers });
        },
    };

    return {
        login, client, trx, provider, games, gamers, brands, freespin, adminusers, admins, bonus, work, clientsShare, logs, credentials, management
    }

})()
export default serverConnection
